/**
 * Pure setters for the Transaction History sub-controller. State shape
 * is `{ rows, pageInfo, loading, glType, timeFrame, dateRange }`, where `pageInfo` mirrors the
 * `@clockout-dev/design-elements` Table contract:
 *
 *   { current: number, perPage: number, total: number }
 *
 * Important: there is intentionally NO `appendPage` and NO `setHasMore`.
 * `setRows` always REPLACES the row list — the screen uses standard
 * page-based pagination, not load-more / infinite scroll.
 */
class TransactionHistoryDelegate {
    setRows(rows) {
        this.setState({ rows: Array.isArray(rows) ? rows : [] });
    }

    setLoading(loading) {
        this.setState({ loading: !!loading });
    }

    setPageInfo(pageInfo) {
        const next = pageInfo && typeof pageInfo === 'object' ? pageInfo : null;
        if (!next) return;
        this.setState((prev) => ({
            pageInfo: { ...prev.pageInfo, ...next },
        }));
    }

    setGlType(glType) {
        this.setState({ glType });
    }
}

export default TransactionHistoryDelegate;
